import { StatusMessage } from "./StatusMessage";

export const HashNotFound = () => (
  <StatusMessage>This link is invalid.</StatusMessage>
);
